
import React from 'react';
import { User } from 'lucide-react';
import { Message } from '@/types/chat';
import { renderSafeHTML, formatMessage } from '@/utils/htmlUtils';

interface ChatMessageProps {
  message: Message;
  renderFilePreview: (file: File) => React.ReactNode;
}

const ChatMessage = ({ message, renderFilePreview }: ChatMessageProps) => {
  return (
    <div className={`flex ${message.sender === 'user' ? 'justify-end' : ''}`}>
      {message.sender === 'ai' && (
        <div className="h-8 w-8 rounded-full bg-goldcore/20 flex-shrink-0 flex items-center justify-center mr-2">
          <img src="/lovable-uploads/0aa296c2-39b8-4316-97b8-2a5754cf1180.png" alt="KnightAI" className="h-5 w-5" />
        </div>
      )}
      
      <div className={`max-w-[80%] p-3 rounded-lg ${
        message.sender === 'user' 
          ? 'bg-tacticalblue/30 rounded-tr-none ml-2 text-softwhite' 
          : 'bg-goldcore/10 rounded-tl-none text-softwhite'
      }`}>
        <div 
          className="chat-message-content"
          dangerouslySetInnerHTML={{ 
            __html: renderSafeHTML(formatMessage(message.text)) 
          }}
        />
        
        {/* Render uploaded files */}
        {message.files && message.files.length > 0 && (
          <div className="mt-2 flex flex-wrap gap-2">
            {message.files.map((file, fileIndex) => (
              <div key={fileIndex} className="relative">
                {renderFilePreview(file)}
              </div>
            ))}
          </div>
        )}
      </div>
      
      {message.sender === 'user' && (
        <div className="h-8 w-8 rounded-full bg-tacticalblue/30 flex-shrink-0 flex items-center justify-center ml-2">
          <User size={16} className="text-softwhite" />
        </div>
      )}
    </div>
  );
};

export default ChatMessage;

